import React from 'react';
import styled from 'styled-components';


const ErrorWrapper = styled.div`
  @import url('https://fonts.googleapis.com/css?family=Titillium+Web&display=swap');
  font-family: 'Titillium Web', sans-serif;
  font-weight: normal;
  font-size: 1.2rem;
  color: #222;
  background-color: #f1f1f1;
  width: 100%;
  margin: 0px;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  div {
    max-width: 500px;
    margin: auto;
  }
  h1 {
    margin: 64px auto 32px;
    font-size: 2.4em;
    font-weight: 400;
    color: #a6dc3d;
  }
  a{
    color: #000;
    font-weight: bold;
    &:hover {
      color: #a6dc3d;
    }
  }
  ul{
    text-align:left;
    list-style-position: inside;
    margin: 20px 0;
    li{
      list-style-type: cirlce;
    }
  }
`;


export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ hasError: true });

    if ((typeof window !== 'undefined') && window.Sentry) {
      window.Sentry.configureScope((scope) => {
        Object.keys(errorInfo).forEach((key) => {
          scope.setExtra(key, errorInfo[key]);
        });
      });
      window.Sentry.captureException(error);
    }
  }

  render() {
    const { hasError } = this.state;

    if (hasError) {
      return (
        <ErrorWrapper>
          <h1>Errore</h1>
          <div>
            <p>&Egrave; stato riscontrato un errore. Assicurati di:</p>
            <ul>
              <li>Essere connesso ad internet</li>
              <li>Utilizzare un browser supportato quale:
                <ul>
                  <li><a rel="noopener noreferrer" href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Mozilla Firefox</a></li>
                  <li><a rel="noopener noreferrer" href="https://www.google.com/chrome/" target="_blank">Google Chrome</a></li>
                  <li><a rel="noopener noreferrer" href="https://www.apple.com/it/safari/" target="_blank">Apple Safari</a></li>
                  <li><a rel="noopener noreferrer" href="https://www.microsoft.com/it-it/windows/microsoft-edge" target="_blank">Microsoft Edge</a></li>
                </ul>
              </li>
              <li>Utilizzare un sistema operativo aggiornato e supportato</li>
            </ul>
            <p>Prova a ricaricare la pagina</p>
          </div>
        </ErrorWrapper>
      );
    }
    return this.props.children;
  }
}
